export default {
	export: 'Export risk raport',
	title: 'Raport title',
	includeInRaport: 'Include in raport',
	includeTitlePage: 'Title page',
	detailedRisks: 'Detailed raport',
	description: 'Raport description',
	includeOverview: 'Risk overview section',
	generate: 'Generate | Generating',
	riskReport: 'Risk management report',
	includeDescription: 'Risk description',
	includeImpactedAssets: 'Impacted assets',
	includeThreats: 'Threats',
	includeVulnerabilities: 'Vulnerabilities',
	includeMitigationMeasures: 'Mitigation measures',
	includeRiskMatrix: 'Risk matrix',
}
